import bind from 'bind-decorator';

import * as classnames from 'classnames/bind';
import chunk from 'lodash/chunk';
import * as React from 'react';
import {Swatch} from 'react-color/lib/components/common';

const styles = require('@mintdata/mint-kit/impl/components/colorPicker/Swatches.less');
const cx = classnames.bind(styles);

export interface ISwatchesProps
{
    colors?:Array<string>;
    numberPerRow?:number;
    onClick:(string) => void;
    selectedColor?:string;
}

export class Swatches extends React.Component<ISwatchesProps, any>
{
    public static defaultProps:Partial<ISwatchesProps> = {
        colors: [],
        numberPerRow: 10,
    };

    @bind
    private _renderSwatch(color)
    {
        const {onClick, selectedColor} = this.props;

        const isSelected = selectedColor === color;

        return (
            <div
                key={color}
                className={cx(styles.swatch, {isSelected})}
            >
                <Swatch
                    color={color}
                    onClick={onClick}
                    focusStyle={{boxShadow: `0 0 2px ${color}`}}
                >
                </Swatch>
            </div>
        );
    }

    public render():JSX.Element
    {
        const {colors, numberPerRow} = this.props;

        return (
            <div className={styles.swatches}>
                {
                    numberPerRow ? (
                        <div>
                            {
                                chunk(colors, numberPerRow).map((chunk, index) =>
                                {
                                    return (
                                        <div
                                            key={index}
                                            className={styles.swatchesRow}
                                        >
                                            {
                                                chunk.map(this._renderSwatch)
                                            }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    ) : (
                        <div className={styles.swatchesSingleRow}>
                            {
                                colors.map(this._renderSwatch)
                            }
                        </div>
                    )
                }
            </div>
        );
    }
}

